$('body').on('click', '.faq_header', function(e) {
    $('.box-a1').find('.level-box').stop().slideUp();
    $(this).closest('.box-a1').find('.level-box').stop().slideToggle();
});
$(".leftlink").insertAfter( ".faq_links span" );
$(".faq_links a:nth-child(2)").addClass( "active" );


// Select all »a« elements with a parent class »links« and add a function that is executed on click
$( '.faq_links a' ).on( 'click', function(e){
	
  // Define variable of the clicked »a« element (»this«) and get its href value.
  var href = $(this).attr( 'href' );

    $('.faq_links a').not(this).removeClass( 'active' );
  $(this).addClass( 'active' );
  
  // Run a scroll animation to the position of the element which has the same id like the href value.
  $( 'html, body' ).animate({
		scrollTop: $( href ).offset().top - 120
  }, '300' );
	
  // Prevent the browser from showing the attribute name of the clicked link in the address bar
  e.preventDefault();

});








